const dry_cleaning = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1_33544)">
      <path d="M19.56 11.3601L13 8.44006V7.00006C13 6.45006 12.55 6.00006 12 6.00006C11.45 6.00006 11 5.55006 11 5.00006C11 4.45006 11.45 4.00006 12 4.00006C12.55 4.00006 13 4.45006 13 5.00006H15C15 3.16006 13.34 1.70006 11.44 2.05006C10.26 2.27006 9.29 3.22006 9.06 4.40006C8.76 5.96006 9.66 7.34006 11 7.82006V8.45006L4.44 11.3701C3.56 11.7501 3 12.6201 3 13.5701V13.5801C3 14.9201 4.08 16.0001 5.42 16.0001H7V22.0001H17V16.0001H18.58C19.92 16.0001 21 14.9201 21 13.5801V13.5701C21 12.6201 20.44 11.7501 19.56 11.3601ZM18.58 14.0001H17V13.0001H7V14.0001H5.42C5.19 14.0001 5 13.8101 5 13.5701C5 13.4001 5.1 13.2501 5.25 13.1901L12 10.1901L18.75 13.1901C18.9 13.2601 19 13.4101 19 13.5801C19 13.8101 18.81 14.0001 18.58 14.0001Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1_33544">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
export default dry_cleaning;
